function PlusIcon()
{
    return(
<svg x="0px" y="0px" viewBox="0 0 128 128" width="70%" height="70%">
<g id="_x33_">
	<path style={{"fill":"white"}} d="M128,63.954c0,2.006-0.797,3.821-2.136,5.127c-1.308,1.337-3.125,2.133-5.166,2.133H71.302v49.356   c0,4.012-3.284,7.292-7.302,7.292c-2.009,0-3.827-0.828-5.166-2.134c-1.308-1.337-2.136-3.152-2.136-5.159V71.214H7.302   c-4.05,0-7.302-3.248-7.302-7.26c0-2.006,0.797-3.853,2.136-5.159c1.308-1.306,3.125-2.134,5.166-2.134h49.395V7.306   c0-4.012,3.284-7.26,7.302-7.26c2.009,0,3.827,0.828,5.166,2.133c1.308,1.306,2.136,3.121,2.136,5.127v49.356h49.395   C124.747,56.662,128,59.91,128,63.954z"/>
</g>
<g id="Layer_1">
</g>
</svg>
    )
}

export default PlusIcon